module.exports = __webpack_public_path__ + "img/4a20d2c.png";